// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import logoFacomLong from "./../../images/LOGOFACOMLONG.png";
import logoFacomSquare from "./../../images/LOGOFACOMSQUARE.png";
import gainsImg from "./../../images/GarageLego.png";
import "./Looser.css";

const Looser = ({ config }) => {
  return (
    <div className="header">
      <div className="logo">
        <img src={config ? config.logo : null} />
      </div>
      <div
        className="title"
        style={{ color: config ? config.textColor : "#000" }}
      >
        <div className="headerTitle">PERDU</div>
        <div className="underTitle">Merci d'avoir jouer avec nous !</div>
      </div>
      <div className="footerInfos">
        <div
          className="secondChance"
          style={{
            backgroundColor: config ? config.secondaryColor : "#000",
            color: config ? config.primaryColor : "#000",
          }}
          onClick={() => window.open(config.redirectClick, "_blank")}
        >
          ACCÉDER À LA BILLETTERIE
        </div>
      </div>
    </div>
  );
};

export default Looser;
